/**
 * @desc 托盘详情
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inPlateMaster.palteDetail.Params, options?: any) {
  return updateResponse(
    http(URL + `/inPlate/palteDetail`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
